module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-tool",
    class: {
      on: _vm.on
    }
  }, [_c('a', {
    staticClass: "icon icon-more",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSwitch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tool-panel"
  }, [_c('a', {
    staticClass: "icon icon-home",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onHome
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon icon-search",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSearch
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon icon-share",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onShare
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d81c80f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/components/AppTool.vue
// module id = 342
// module chunks = 0